import { colors } from "@components/ui/colors";
import { InvoiceCustomStyle } from "../types/invoiceCustomStyle.types";
import { InvoiceStyleTokens } from "../utils/createInvoiceStyleTokens";

export const defaultInvoiceCustomStyle: InvoiceCustomStyle = {
  colors: {
    pageBackground: "#F8F9FA",
    emailHeader: colors.orange[50],
    cardBackground: "#FFFFFF",
    title: colors.orange.base,
    subTitle: "#202020",
    body: "#777779",
    border: "var(--fx-surface-borderstrong, #CBD5E1)",
    total: colors.orange.base,
    icon: colors.orange.base,
  },

  typography: {
    fontFamily: "Inter",
    headingFontFamily: "Inter",
  },

  borders: {
    color: "#F1F5F9",
    width: 0,
    radius: 16,
    style: "solid",
  },

  spacing: {
    cardGap: 12,
  },

  icons: {
    service: "cleaning",
    visits: "calendar",
    location: "location",
    notes: "document",
    payment: "payment",
    additionalCharges: "assignment",
  },

  labels: {
    increasePercentageByFrequency: "Service fee",
  },
};

export const createLabelTextSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.body,
  fontWeight: 800,
  fontSize: 10,
  textTransform: "uppercase",
  lineHeight: 1,
});

export const createBodyTextSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.body,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.5,
});

export const createStrongTextSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.subTitle,
  fontSize: 14,
  fontWeight: 900,
  lineHeight: 1.25,
});

export const createCompanyNameSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.subTitle,
  fontFamily: styleTokens.typography.headingFontFamily,
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.25,
  overflowWrap: "anywhere",
});
